export default __webpack_public_path__ + "static/media/temp.55f6a994.xlsx";